module.exports = __webpack_public_path__ + "media/images/logo-desjardins-b78af954f8d41b373fb7550997a5fe95.png";